/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryResourceGroup extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryResourceGroup");
    }

    getFixupPrototypeFunction() { return ResourceQueryResourceGroup.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryResourceGroup>): ResourceQueryResourceGroup {
        let obj = Object.assign(new ResourceQueryResourceGroup(), model);
        ResourceQueryResourceGroup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryResourceGroup>): ResourceQueryResourceGroup {
        if (!model) return null;
        return ResourceQueryResourceGroup.newInstance(<ResourceQueryResourceGroup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryResourceGroup) {
        if (!obj) return;

        models.ResourceQueryResourceGroup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryResourceGroup): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryResourceGroup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Group to which the resource belongs to.
     */
    resource_groups: Array<string>;

}
